import React, { useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import "../AdminComponent/AddEmployeeModal.css";
import { useAuth } from "../../Component/Authentication/AuthContext";
import { toast } from "react-toastify";
import axios from "axios";
import { Api, BaseUrl } from "../../Config/Api";
import { useDispatch } from "react-redux";
import { setUserDetails } from "../../Redux/Action";

const AddEmployeeModal = ({ open, onClose }) => {
  const { setLoading, logout } = useAuth();
  const dispatch = useDispatch();
  const token = sessionStorage.getItem("authToken");
  const [errorMessage, setErrorMessage] = useState("");
  const initialFormData = {
    name: "",
    employeeCode: "",
    email: "",
    contact: "",
    bloodgroup: "",
    location: "",
    manager: "",
    password: "",
    dob: "",
    doj: "",
    department: "",
    status: "",
    don: "",
    bio: "",
    designation: "",
    experience: "",
    image: null,
  };
  const [emptyFields, setEmptyFields] = useState([]);
  const [file, setFile] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    employeeCode: "",
    email: "",
    contact: "",
    bloodgroup: "",
    location: "",
    manager: "",
    password: "",
    dob: "",
    doj: "",
    department: "",
    status: "",
    don: "",
    bio: "",
    designation: "",
    experience: "",
    image: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "email" && value.includes("@")) {
      setErrorMessage("Please do not add the domain (e.g., @cvinfotech.com)");
    } else {
      setErrorMessage(""); // Clear error message if input is valid
    }
    if (name === "image") {
      setFile(e.target.files[0]);
    } else {
      setFormData({ ...formData, [name]: value });
    }
    if (value.trim() !== "") {
      setEmptyFields(emptyFields.filter((field) => field !== name));
    }
  };

  const findEmptyFields = () => {
    const empty = Object.keys(formData).filter((key) => {
      if (key === "don" && formData.status !== "Notice Period") {
        return false;
      }

      if (key === "image") {
        return !file;
      }

      return !formData[key] || formData[key].trim() === "";
    });
    setEmptyFields(empty);
    return empty;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const empty = findEmptyFields();

    if (formData.status === "Notice Period" && !formData.don) {
      alert("Please fill in the Notice End Date.");
      return;
    }

    if (empty.length > 0) {
      alert(`Please fill in the following fields: ${empty.join(", ")}`);
      return;
    }

    setLoading(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("employee_code", formData.employeeCode);
      formDataToSend.append("email", formData.email + "@cvinfotech.com");
      formDataToSend.append("mobile", formData.contact);
      formDataToSend.append("blood_group", formData.bloodgroup);
      formDataToSend.append("location", formData.location);
      formDataToSend.append("designation", formData.designation);
      formDataToSend.append("password", formData.password);
      formDataToSend.append("reporting_manager", formData.manager);
      formDataToSend.append("doj", formData.doj);
      formDataToSend.append("dob", formData.dob);
      formDataToSend.append("department", formData.department);
      formDataToSend.append("experience", formData.experience);
      formDataToSend.append("status", formData.status);
      formDataToSend.append("biometrics", formData.bio);
      // formDataToSend.append("login_token", token);
      if (file) formDataToSend.append("image", file);

      if (formData.status === "Notice Period") {
        formDataToSend.append("notice_period_end_date", formData.don);
      }

      const response = await axios.post(
        `${BaseUrl}${Api.ADD_EMPLOYEE_DETAILS}`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("qwwqwwqwqwwww",response.data)
      if (response?.data?.authenticated === false) {
        toast.error(response?.data?.mssg[0], {
          position: "top-center",
          autoClose: 1000,
        });
        logout();
        setLoading(false);
      } else {
        if (response?.data?.valid === false) {
          setLoading(false);
          toast.error(response?.data?.mssg[0], {
            position: "top-center",
            autoClose: 1000,
          });
        } else {
          if (response?.data?.success === true) {
            toast.success("Employee added successfully", {
              position: "top-center",
              autoClose: 1000,
            });

            fetchEmployees();
            setFormData(initialFormData);
          } else {
            toast.error(response?.data?.mssg, {
              position: "top-center",
              autoClose: 1000,
            });
            setLoading(false);
          }
        
        }
      }
    } catch (error) {
      console.error("API call failed:", error);
      alert("An error occurred. Please try again.");
      setLoading(false);
    } finally {
    }
  };

  const fetchEmployees = async () => {
    try {
      // const responseData = await axios.get(
      //   `${BaseUrl}${Api.GET_EMPLOYEE}?login_token=${token}`
      // );
      const responseData = await axios.get(`${BaseUrl}${Api.GET_EMPLOYEE}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      if (responseData?.data?.authenticated === false) {
        toast.error(responseData?.data?.mssg[0], {
          position: "top-center",
          autoClose: 1000,
        });
        logout();
        setLoading(false);
      } else {
        if (responseData?.data?.valid === false) {
          toast.error(responseData?.data?.mssg[0], {
            position: "top-center",
            autoClose: 1000,
          });
          setLoading(false);
        } else {
          dispatch(setUserDetails(responseData?.data?.data));
          onClose();
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("API call failed:", error);
      alert("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      center
      showCloseIcon={false}
      closeOnOverlayClick={false}
      classNames={{ modal: "custom-modal" }}
    >
      <div
        style={{
          backgroundColor: "white",

          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          maxWidth: "800px",
          width: "100%",
          margin: "auto",
          paddingRight: 30,
          paddingLeft: 30,
          paddingBottom: 20,
          paddingTop: 20,

          position: "relative",
        }}
      >
        <button
          onClick={() => {
            onClose();
            setFormData(initialFormData);
          }}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            backgroundColor: "transparent",
            border: "none",
            fontSize: "30px",
            cursor: "pointer",
            fontWeight: 700,
          }}
        >
          &times;
        </button>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            fontSize: 30,
            paddingLeft: 100,
            fontWeight: 700,
          }}
        >
          <h2 style={{ marginBottom: "20px" }}>Insert Employee Data</h2>
        </div>
        <form onSubmit={handleSubmit} className="form-grid">
          <div className="form-group">
            <label htmlFor="name">Name:</label>
            <input
              type="text"
              name="name"
              id="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="employeeCode">Employee Code:</label>
            <input
              type="text"
              name="employeeCode"
              id="employeeCode"
              value={formData.employeeCode}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email ID:</label>
            {/* <input
              type="email"
              name="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div> */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <input
                type="text"
                name="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                required
                style={{ flex: 1, paddingRight: "0px" }}
              />
              <span style={{ marginLeft: "-120px" }}>@cvinfotech.com</span>
            </div>
            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
          </div>
          <div className="form-group">
            <label htmlFor="contact">Contact:</label>
            <input
              type="text"
              name="contact"
              id="contact"
              value={formData.contact}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="bloodgroup">Blood Group:</label>
            <input
              type="text"
              name="bloodgroup"
              id="bloodgroup"
              value={formData.bloodgroup}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="location">Location:</label>
            <input
              type="text"
              name="location"
              id="location"
              value={formData.location}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="designation">Designation:</label>
            <input
              type="text"
              name="designation"
              id="designation"
              value={formData.designation}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="experience">Experience:</label>
            {/* <input
              type="text"
              name="experience"
              id="experience"
              value={formData.experience}
              onChange={handleChange}
              required
            /> */}
            <select
              name="experience"
              id="experience"
              value={formData.experience}
              onChange={handleChange}
              required
            >
              <option value="">Select Experience</option>
              <option value="Experience">Experience</option>
              <option value="Fresher">Fresher</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              name="password"
              id="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="manager">Reporting Manager:</label>
            <input
              type="text"
              name="manager"
              id="manager"
              value={formData.manager}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="dob">Date of Birth:</label>
            <input
              type="date"
              name="dob"
              id="dob"
              value={formData.dob}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="doj">Date of Joining:</label>
            <input
              type="date"
              name="doj"
              id="doj"
              value={formData.doj}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="department">Department:</label>
            <select
              name="department"
              id="department"
              value={formData.department}
              onChange={handleChange}
              required
            >
              <option value="">Select Department</option>
              <option value="Web  Development">Web development</option>
              <option value="Apps Development">Apps Development</option>
              <option value="Designer">Designer</option>
              <option value="App Marketing">App Marketing</option>
              <option value="Seo">Seo</option>
              <option value="Project Coordinator">Project coordinator</option>
              <option value="Management">Management</option>
              <option value="Backend Development">Backend Development</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="status">Employee Status:</label>
            <select
              name="status"
              id="status"
              value={formData.status}
              onChange={handleChange}
              required
            >
              <option value="">Select Status</option>
              <option value="Prohibition">Prohibition</option>
              <option value="Full time">Full time</option>
              <option value="Notice Period">Notice Period</option>
              <option value="Intern">Intern</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>

          {formData.status == "Notice Period" && (
            <div className="form-group">
              <label htmlFor="don">Notice End Date:</label>
              <input
                type="date"
                name="don"
                id="don"
                value={formData.don}
                onChange={handleChange}
                required
              />
            </div>
          )}
          <div className="form-group">
            <label htmlFor="bio">Biometric Code:</label>
            <input
              type="text"
              name="bio"
              id="bio"
              value={formData.bio}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="image">Employee Image:</label>
            <input
              type="file"
              accept="image/*"
              name="image"
              id="image"
              value={formData.image}
              onChange={handleChange}
              required
            />
          </div>
          <div className="button">
            <button type="submit" className="myButton2">
              Submit Details
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AddEmployeeModal;
